// Common
import { NonScCommon } from '../common/nonsc.common'

export class ValidateUtility {

  static isLocation(input) {

    // Validate Input
    if (!input) return false

    // Validate Address
    const address = [
      'tumbonPrefix',
      'tumbonName',
      'amphurPrefix',
      'amphurName',
      'provinceName',
      'zipCode',
    ].map(e => input[e])

    return address.every(e => !!e)
  }

  static isArea(input) {
    return (
      parseInt(input) > 0 && parseInt(input) < 2001
    )
  }

  static isRole(input) {
    
    // Role List
    const list = (
      NonScCommon.role.map(e => e.value)
    )

    return list.includes(input)
  }

  static isStructure(input) {

    // Construct List
    const list = (
      NonScCommon.construct.map(e => e.value)
    )

    return list.includes(input)
  }

  static isDate(input) {
    return !isNaN(new Date(input).getTime())
  }

  static isAddrNo(input) {
    return /^\d+\s*(\/\s*\d+)?\s*(-\s*\d+)?$/gm.test(input)
  }

  static isMobileNo(input) {
    return /^(?:66|0)(?:[689]\d{8})$/gm.test(input)
  }

  static isEmail(input) {
    return /^[\w\.\-]+@([\w\-]+\.)+[\w\-]{2,4}$/gm.test(input)
  }

  static isLatitude(input) {
    return (
      /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/.test(input)
    )
  }

  static isLongitude(input) {
    return (
      /^[-+]?((1[0-7]\d|[1-9]?\d)(\.\d+)?|180(\.0+)?)$/.test(input)
    )
  }

  static isURL(input) {
    return (
      /^(http|https)(\:\/{2})([^\W+]\S+)$/.test(input)
    )
  }

  static isLocale(code, input) {
    
    // RegExp
    const regex = {
      chi: /^[\u4E00-\u9FFF\d\-\.\s]+$/gm,
      eng: /^[a-zA-Z\d\-\.\s]+$/gm,
      tha: /^[\u0E01-\u0E5B\d\-\.\s]+$/gm,
    }

    // Input Validator
    const tester = regex[code]

    return (
      tester ? tester.test(input) : false
    )
  }
}


// WEBPACK FOOTER //
// ./src/features/nonsc/utils/validate.js